import * as React from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import dayjs from "dayjs";
import { ReportProgress } from "../../../types/project";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";
import { DesktopDateTimePicker } from "@mui/x-date-pickers";
import { elapsed } from "../../../utils/dateHelper";
import BaseModal from "../../../components/global/BaseModal";

const ForceCheckoutModal = ({
  open,
  onClose,
  onSubmit,
  progress,
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: (progress_id: number, checkout_date: Date) => Promise<void>;
  progress: ReportProgress | null;
}) => {
  const [date, setDate] = React.useState(new Date());
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = () => {
    if (!date) {
      toast.error("Please fill in all the required fields.");
      return;
    }
    if (dayjs(date).isBefore(dayjs(progress?.check_in!))) {
      toast.error(
        "Cannot checkout Independent Professional before his/her current checkin time!"
      );
      return;
    }
    setLoading(true);
    onSubmit(progress?.id!, date).finally(() => {
      setLoading(false);
      onClose();
    });
  };

  const workingTime = React.useMemo(() => {
    if (!!progress && !!date) {
      return elapsed(
        new Date(date).getTime(),
        new Date(progress.check_in).getTime(),
        false
      );
    }
    return "";
  }, [progress, date]);

  React.useEffect(() => {
    if (open) {
      setDate(new Date());
    }
  }, [open]);

  const footer = (
    <>
      <Button onClick={onClose} disabled={loading}>
        Cancel
      </Button>
      <LoadingButton onClick={handleSubmit} loading={loading}>
        Checkout
      </LoadingButton>
    </>
  );

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Force Checkout"
      footer={footer}
      maxWidth="xs"
    >
      <Box sx={{ p: 3, display: "grid", gap: 2 }}>
        <TextField
          label="Check-in Time"
          value={dayjs(progress?.check_in).format("MM/DD/YYYY hh:mm A")}
          disabled
          fullWidth
        />
        <DesktopDateTimePicker
          sx={{ width: "100%" }}
          onChange={(val: any) => setDate(val!)}
          value={dayjs(date)}
          label="Forced Checkout Time"
          slotProps={{
            textField: {
              helperText: !date && "Please set a valid date and time",
            },
          }}
        />
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          Working Time → {workingTime}
        </Typography>
      </Box>
    </BaseModal>
  );
};
export default ForceCheckoutModal;
